import React from 'react';
import styled from '@emotion/styled';
import { ThemeProps } from 'theme/base';

export interface SliderProps {
  count: number;
  selected: number;
}

export const SliderContainer = styled.div(({ theme }: ThemeProps) => ({
  position: 'relative',
  marginBottom: theme.custom.spacing.large
}));

const SliderBar: any = styled.div(
  ({ theme }: ThemeProps) =>
    ({
      display: 'flex',
      height: 8,
      borderRadius: 4,
      backgroundColor: theme.custom.colors.group10.base,
      position: 'relative',
      opacity: '0.2'
    }) as any
);

interface SlideProps extends ThemeProps {
  percent: number;
  left: number;
}

const Slide: any = styled.div(({ theme, percent, left }: SlideProps) => ({
  height: 8,
  borderRadius: 4,
  backgroundColor: theme.custom.colors.group1.base,
  left: `${left}%`,
  width: `${percent}%`,
  position: 'absolute',
  transition: `left ${theme.custom.transitions.smooth}`,
  top: 0
}));

export const Slider = (props: SliderProps) => {
  const { count, selected } = props;
  const percent: number = (1 / count) * 100;
  const left: number = percent * selected;
  return (
    <SliderContainer>
      <SliderBar />
      <Slide percent={percent} left={left} count={count} />
    </SliderContainer>
  );
};
